<template>
  <router-view v-if="!loading" />
</template>

<script>
  import packageJson from '../package.json';

  export default {
    name: 'App',

    data: () => ({
      loading: true,
    }),

    metaInfo() {
      return {
        title: 'MaxQuest',
        titleTemplate: process.env.VUE_APP_SEO_TITLE || 'MaxQuest | Play Games of Skill to Win Real Cash Prizes',
      };
    },

    created() {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');

      mq.addEventListener('change', (e) => {
        this.$vuetify.theme.dark = e.matches;
      });

      setTimeout(() => (this.loading = false), 1000);
    },

    beforeMount() {
      // eslint-disable-next-line no-console
      console.log(`%c v${packageJson.version}`, 'color: lightseagreen; font-size: 20px;');
      // eslint-disable-next-line no-console
      console.log(
        '%cWarning: Using this console may allow attackers to impersonate you and steal your information using an attack called Self-XSS. Do not enter or paste code that you do not understand!',
        'color: red; font-size: 20px;',
      );
    },
  };
</script>

<style lang="scss">
  @import '@/scss/inputStyling.scss';

  .v-main[app] {
    transition: 0.35s ease;
    will-change: contents;
    transform-style: preserve-3d;

    @media screen and (min-width: 960px) and (max-width: 1280px) {
      &.logged-in {
        padding-left: 120px !important;
      }
    }
  }

  .nav-drawer.v-navigation-drawer {
    transition: 0.35s ease;
    will-change: transform, visibility, width;
    transform-style: preserve-3d;

    @media screen and (max-width: 600px) {
      transition: 0.2s ease;
    }
  }
</style>
